import { LogEvent } from 'types';
import { restService } from 'utilities';

export interface GetRecentLogsInput {
  limit?: number;
}

export interface GetRecentLogsOutput {
  logs: LogEvent[];
}

const getRecentLogs = async ({
  limit = 50,
}: GetRecentLogsInput = {}): Promise<GetRecentLogsOutput> => {
  try {
    const params: Record<string, any> = {
      limit,
    };

    const response = await restService<any>({
      endpoint: '/logs/recent',
      method: 'GET',
      params,
    });

    // Return empty array if no response
    if (!response?.data) {
      return { logs: [] };
    }

    // Check if data is directly an array
    if (Array.isArray(response.data)) {
      return { logs: response.data };
    }

    // Check if response has nested data array
    if (response.data.data && Array.isArray(response.data.data)) {
      return { logs: response.data.data };
    }

    // Fallback: return empty array
    return { logs: [] };
  } catch (error) {
    console.error('Error fetching recent logs:', error);
    return { logs: [] };
  }
};

export default getRecentLogs;
